import router from './router'
import { isRelogin } from '@/axios/service'
import { getAccessToken } from '@/utils/auth'
import { useTitle } from '@/hooks/common/useTitle'
import { usePageLoading } from '@/hooks/common/usePageLoading'
import { useUserStoreWithOut } from '@/stores/modules/user'
import { goTop } from './utils'

/**
 * 配置百度统计的路由埋点。
 * 这里只在 `_hmt` 存在时上报，避免开发环境报错。
 */
export function setupBaiduAnalytics() {
  router.afterEach((to) => {
    if ((window as any)._hmt) {
      ;(window as any)._hmt.push(['_trackPageview', to.fullPath])
    }
  })
}

const { loadStart, loadDone } = usePageLoading()

/**
 * 需要强制登录校验的路由白名单。
 * 当前官网页面均为公开页，因此暂时为空数组。
 */
const blackList: string[] = [
  // '/login',
]

/**
 * 路由前置守卫。
 * 公开页不再阻塞等待用户信息接口，避免 token 失效或接口超时时首屏白屏。
 */
router.beforeEach(async (to, _from, next) => {
  loadStart()

  if (getAccessToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      return
    }

    const userStore = useUserStoreWithOut()
    // 标记当前路由是否必须等待登录态校验完成。
    const requiresAuth = blackList.includes(to.path)

    if (!userStore.getIsSetUser) {
      // 公开页直接放行，用户信息改为后台补拉，避免首屏被接口超时卡住。
      if (!requiresAuth) {
        isRelogin.show = true
        userStore
          .setUserInfoAction()
          .catch((error) => {
            console.error('请求超时或失败:', error)
          })
          .finally(() => {
            isRelogin.show = false
          })

        next()
        return
      }

      try {
        isRelogin.show = true
        await userStore.setUserInfoAction()
      } catch (error) {
        console.error('请求超时或失败:', error)
      } finally {
        isRelogin.show = false
      }
    }

    next()
    return
  }

  if (blackList.indexOf(to.path) === -1) {
    next()
    return
  }

  next(`/?redirect=${to.fullPath}`)
})

/**
 * 路由切换完成后的公共收尾逻辑。
 * 这里统一处理标题、加载态和滚动位置恢复。
 */
router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  loadDone()

  setTimeout(() => {
    goTop()
  }, 0)
})
